<template>
    <div>
        <div class="shadow_box rounded-lg p-6 relative flex flex-col">
            <p class="title"><strong>Pesquisa</strong></p>
            <form class="mt-1 w-full" @submit.prevent="reloadTable">
                <div class="flex flex-wrap mb-4 px-4">
                    <select-input v-model="search.type" class="lg:pr-6 w-full lg:w-1/4" label="Tipo">
                        <option :value="null" />
                        <option v-for="(item) in type_options" :key="item.name" :value="item.id">{{ item.name }}</option>
                    </select-input>
                    <select-input v-model="search.frequency" class="lg:pr-6 w-full lg:w-1/4" label="Frequência">
                        <option :value="null" />
                        <option v-for="(item) in frequency_options" :key="item.name" :value="item.id">{{ item.name }}
                        </option>
                    </select-input>
                    <select-input v-model="search.receiver" class="lg:pr-6 w-full lg:w-1/4" label="Destinatário">
                        <option :value="null" />
                        <option v-for="(item) in destinatario_options" :key="item.name" :value="item.id">{{ item.name }}
                        </option>
                    </select-input>
                    <select-input v-model="search.send_to" class="lg:pr-6 w-full lg:w-1/4" label="Enviar Para">
                        <option :value="null" />
                        <option v-for="(item) in send_to_options" :key="item.name" :value="item.id">{{ item.name }}</option>
                    </select-input>
                </div>
                <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
                    <button
                        class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">
                        <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                        Pesquisar
                    </button>
                    <button class="btn flex items-center text-purple-100 font-roboto font-medium uppercase
                px-6 py-2.5 text-xs leading-tight border-solid border-2 border-purple-100" @click="clearSearch">
                        <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                        Limpar
                    </button>
                </div>
            </form>
        </div>

        <Head title="Notificações" />
        <div class="shadow_box rounded-lg p-6 mt-4">
            <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Criar Notificação</h1>
            <data-table v-if="loadTable" v-model:columns="columns" :query="getQuery(search, 'search2')"
                no-data-label="Nenhuma notificação cadastrada" no-result-label="Nenhuma notificação encontrada"
                route="notification/list">
                <template #table.cell.content.actions="{ value, row }">
                    <div class="inline-grid grid-cols-2 gap-4 ">
                        <span class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm"
                            @click="openModalEdit(row)"><font-awesome-icon class="text-white pr-2"
                                icon="fa-pencil" />Editar</span>
                        <span class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm"
                            @click="openModalConfirmDelete(row)"><font-awesome-icon class="text-white pr-2"
                                icon="fa-trash-can" />Excluir</span>
                    </div>
                </template>
                <template #grid.content.body.actions="{ value, row }">
                    <div class="inline-grid grid-cols-2 gap-4 ">
                        <span class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm"
                            @click="openModalEdit(row)"><font-awesome-icon class="text-white pr-2"
                                icon="fa-pencil" />Editar</span>
                        <span class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm"
                            @click="openModalConfirmDelete(row)"><font-awesome-icon class="text-white text-lg pr-2"
                                icon="fa-trash-can" />Excluir</span>
                    </div>
                </template>

                <template #after.reload-button>
                    <button class="flex items-end font-roboto font-medium btn-purple uppercase"
                        @click.prevent="openModalEdit({})">
                        <font-awesome-icon class="text-white text-lg mr-0 lg:mr-2" icon="fa-plus" />
                        <span class="hidden lg:block"> Adicionar Notificação</span>
                    </button>
                </template>
            </data-table>
        </div>
        <modal-delete ref="modalDelete" @confirm="reloadTable" />
        <modal-edit ref="modalEdit" title="Notificações" url="notification" @submitForm="reloadTable"
            id="modal-adicionar-notificacao">
            <template #form="{ item }">
                <check-group v-model="item.type" :options="options_type" class="lg:pr-6 w-full mb-3" label="Tipo"
                    :error="item.errors.type" required="true" />

                <radiobox v-model="item.frequency" @change="$v => changeRadios($v, item)" :options="options_frequency"
                    class="lg:pr-6 w-full mb-3" label="Frequência" required="true" :error="item.errors.frequency" />

                <date-time-input v-if="item.frequency == 1" v-model="item.send_date_time" class="lg:pr-6 w-1/2 mb-3"
                    label="Data/Hora de envio" :error="item.errors.send_date_time" required="true" />

                <template v-if="item.frequency == 2">
                    <multi-select-input v-model="item.days_of_week" :options="weekoptionsAll"
                        :error="item.errors.days_of_week" appendTo="#modal-adicionar-notificacao"
                        class="lg:pr-6 w-full lg:w-1/2 mb-3" label="Dias da Semana" required="true" />

                    <time-input v-model="item.time_start" :error="item.errors.time_start" class="lg:pr-6 w-full lg:w-1/2"
                        label="Horário de envio" required="true" />

                    <date-input v-model="item.date_start" :error="item.errors.date_start"
                        class="lg:pr-6 mt-6 w-full lg:w-1/2" label="Data de Início" required="true" />

                    <date-input v-model="item.date_end" :error="item.errors.date_end" class="my-6 w-full lg:w-1/2"
                        label="Data Final" />
                </template>

                <text-input v-model="item.title" :error="item.errors.title" class="lg:pr-6 w-full lg:w-3/4 mb-3"
                    label="Titulo" required="true" />
                <textarea-input v-model="item.description" :error="item.errors.description"
                    class="lg:pr-6 w-full lg:w-3/4 mb-3" label="Notificação (Corpo da mensagem)" required="true" />
                <radiobox v-model="item.send_to" :options="options_send_to" class="lg:pr-6 w-1/2"
                    :error="item.errors.send_to" label="Enviar Para" required="true" @change="clearSelectRecipients" />

                <radiobox v-model="item.receiver" required="true" :error="item.errors.receiver"
                    :options="options_destinatario" class="lg:pr-6 w-1/2 mt-3" label="Destinatário"
                    @change="changeSpecific(item)" />

                <multi-select-input ref="selectrecipients" v-if="item.send_to == 1 && item.receiver != ''"
                    v-model="item.recipients" :options="options_all" :error="item.errors.recipients"
                    appendTo="#modal-adicionar-notificacao" class="lg:pr-6 w-full lg:w-1/2 mb-3" label="Destinatário" />
            </template>
        </modal-edit>
    </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import TextInput from '@/Shared/TextInput'
import DataTable from '@/Shared/DataTable'
import TextareaInput from '@/Shared/TextareaInput.vue'
import SelectInput from '@/Shared/SelectInput'
import CheckGroup from '@/Shared/CheckGroup.vue'
import Radiobox from '@/Shared/RadioInput.vue'
import DateTimeInput from '@/Shared/DateTimeInput.vue'
import VueSelectInput from '@/Shared/VueSelectInput.vue'
import MultiSelectInput from '@/Shared/MultiSelectInput.vue'
import DateInput from '@/Shared/DateInput.vue'
import TimeInput from '@/Shared/TimeInput.vue'

import { queryMixin } from '@/Mixins/Query'

export default {
    components: {
        Head,
        LoadingButton,
        ModalDelete,
        ModalEdit,
        TextInput,
        DataTable,
        TextareaInput,
        CheckGroup,
        Radiobox,
        DateTimeInput,
        SelectInput,
        VueSelectInput,
        MultiSelectInput,
        DateInput,
        TimeInput,
    },
    props: {
        type_options: Object,
        frequency_options: Object,
        destinatario_options: Object,
        send_to_options: Object,
        brand: Array,
        salesPromoter: Array,
        product: Array,
        marketNetwork: Array,
        weekoptionsAll: Array,
    },
    layout: Layout,
    mixins: [queryMixin],
    data () {
        return {
            options_all: [],
            checkboxValues: [],
            options_type: [
                {
                    label: 'Email',
                    value: 1,
                    name: 'type',
                },
                {
                    label: 'Push',
                    value: 2,
                    name: 'type',

                },
                {
                    label: 'Notificação',
                    value: 3,
                    name: 'type',
                },
            ],
            options_frequency: [
                {
                    label: 'Unico ',
                    value: 1,
                    name: 'frequency',
                },
                {
                    label: 'Recorrente',
                    value: 2,
                    name: 'frequency',
                },
            ],
            options_destinatario: [
                {
                    label: 'Rede ',
                    value: 1,
                    name: 'market_network',
                },
                {
                    label: 'Marca',
                    value: 2,
                    name: 'brand',
                },
                {
                    label: 'Promotor',
                    value: 3,
                    name: 'sales_promoter',
                },
                {
                    label: 'Produto',
                    value: 4,
                    name: 'product',
                },
            ],
            options_send_to: [
                {
                    label: 'Específico ',
                    value: 1,
                    name: 'send_to',
                },
                {
                    label: 'Todos',
                    value: 2,
                    name: 'send_to',
                },
            ],
            search: {
                type: '',
                frequency: '',
                receiver: '',
                send_to: '',
            },
            loadTable: true,
            columns: [
                {
                    uniqid: 'notification_title',
                    label: 'Titulo',
                    field: 'title',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'notification_body',
                    label: 'Notificação',
                    field: 'description',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'notification_date',
                    label: 'Data de Envio',
                    field: 'send_date_time',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => val ? this.$filters.formatDateTime(row.send_date_time) : ''
                },
                {
                    uniqid: 'actions',
                    label: 'Ações',
                    field: 'id',
                    visible: true,
                    align: 'center',
                    classes: 'py-3 border-b',
                    headerClass: 'p-4',
                },
            ],
        }
    },
    methods: {
        openModalConfirmDelete (item) {
            this.$refs.modalDelete.openModalDelete(item, `/notification/${item.id}`, `Deseja realmente excluir a região ${item.title}?`)
        },
        openModalEdit (item) {
            this.changeSelectOptions(item.receiver)

            this.$refs.modalEdit.openModalEdit({
                id: item.id,
                type: item.type ?? [],
                frequency: item.frequency,
                send_date_time: item.send_date_time,
                title: item.title,
                date_start: item.date_start,
                date_end: item.date_end,
                time_start: item.time_start,
                description: item.description,
                receiver: item.receiver ?? [],
                send_to: item.send_to,
                recipients: item.recipients,
                days_of_week: item.days_of_week || [],
                errors: {},
            })
        },
        reloadTable () {
            this.loadTable = false
            setTimeout(() => this.loadTable = true, 10)
        },
        changeRadios (value, item) {
            item.frequency = value

            if (value == 1) {
                item.date_start = null
                item.date_end = null
                item.time_start = null
            }

            else if (value == 2)
                item.send_date_time = null
        },
        clearSearch () {
            this.search = {
                type: '',
                frequency: '',
                receiver: '',
                send_to: '',
            };
            this.reloadTable();
        },

        clearSelectRecipients () {
            this.$refs.selectrecipients?.clearSelects()
        },

        changeSelectOptions (value) {
            if (value == 1) {
                this.options_all = this.marketNetwork;
            } else if (value == 2) {
                this.options_all = this.brand;
            } else if (value == 3) {
                this.options_all = this.salesPromoter;
            } else {
                this.options_all = this.product;
            }
        },

        changeSpecific (item) {
            item.recipients = []
            this.clearSelectRecipients()
            this.changeSelectOptions(item.receiver)
        },
    },
}
</script>
